import { SquadupOptions } from "./squadup/squadup-options"

export const ADDRESS_ORDER_QUESTIONS: Partial<SquadupOptions> = {
  orderQuestions: [
    {
      question: "Address Line #1",
      type: "text",
      required: true,
    },
    {
      question: "Address Line #2",
      type: "text",
      required: false,
    },
    {
      question: "City",
      type: "text",
      required: true,
    },
    {
      question: "State",
      type: "dropdown",
      options: [
        "AL",
        "AK",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
        "International",
      ],
      required: true,
    },
    {
      question: "Zip code",
      type: "text",
      required: true,
    },
    {
      question: "Phone Number",
      type: "text",
      required: true,
    },
  ],
}
